import { commonFilter } from './filter';

export default {
  pageName: 'Nikke',
  pageId: '25030',
  pagePath: '/opinion/Nikke',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
    MetricsTab: {
      buttonId: '25030101',
    },
    SelectedItem: {
      buttonId: '25030106',
    },
    Rank: {
      buttonId: '25030107',
    },
    Open: {
      buttonId: '25030108',
    },
    Keywords: {
      buttonId: '25030109',
    },
    GPT_Get_Btn: {
      buttonId: '25030110',
    },
    TAB_AnalysisTAB: {
      buttonId: '25030111',
    },
    DownloadTable: {
      buttonId: '25030112',
    },
  },
  card: {
    nikkeChart: {
      line: {
        buttonId: '25030103',
      },
      pie: {
        buttonId: '25030105',
      },
      bar: {
        buttonId: '25030104',
      },
      download: {
        buttonId: '25030102',
      },
    },
  },
};
